export const PtBrLocale = {
    page: {
        txtTitle: 'UNVOX | Remova os vocais na hora',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'logo da unvox',
        },
        action: {
            txtBack: 'Voltar',
            txtRetry: 'Tentar novamente',
            txtStartOver: 'Começar de novo',
        },
        job: {
            txtCheckingStatus: 'Verificando status do processamento',
            txtIdLabel: 'ID do processamento',
        },
        footer: {
            linkPrivacyPolicy: 'Política de Privacidade',
            linkTerms: 'Termos de Uso',
            linkRefunds: 'Reembolsos',
            linkSupport: 'Suporte',
            txtAllRightsReserved: 'Todos os direitos reservados.',
            txtBugReportsAndFeatures: 'Relatos de bugs e solicitações de funcionalidades',
        },
        share: {
            title: 'UNVOX | Remoção de vocal com um clique',
            text: 'Transforme suas músicas favoritas em instrumentais prontos para karaokê!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Remoção de vocal com um clique',
            txtHeroSubtitle: 'Instrumentais instantâneos da sua faixa ou direto do YouTube',
            txtInputTypeLabel: 'Tipo de entrada',
            txtInputTypeFile: 'Enviar arquivo de áudio',
            txtInputTypeYoutube: 'Link do YouTube',
            txtInputFilePick: 'Escolher arquivo',
            txtInputFileSub: 'Formatos de áudio comuns ({{formats}}), até {{size}} MB.',
            txtPreviewAction: 'Remover vocais',
            txtPreviewFailed: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
            txtUploadSelectFile: 'Nenhum arquivo selecionado',
            txtYoutubeLabel: 'URL do YouTube',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Cole um link público do YouTube.',
            txtYoutubeMissing: 'Cole uma URL do YouTube.',
            txtYoutubeInvalid: 'Informe uma URL válida do YouTube.',
            txtYoutubeTooLong: 'Esse vídeo tem mais de 15 minutos. Escolha um vídeo mais curto.',
            txtCheckoutUploadFailed: 'Falha no upload. Tente novamente.',
            txtUploadMissing: 'Escolha um arquivo antes de enviar.',
            txtFileTypeInvalid: 'Tipo de arquivo não suportado. Envie um arquivo de áudio (ex.: {{formats}}).',
            txtFileTooLarge: 'Arquivo muito grande. O tamanho máximo é {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Não foi possível criar a prévia',
            txtUnavailableBody: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
            txtPreparingTitle: 'Preparando prévia',
            txtPreparingBody: 'Isso pode levar até 2 minutos',
        },
        payment: {
            txtUnavailableTitle: 'Não foi possível criar a prévia',
            txtUnavailableBody: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
            txtPreparingTitle: 'Preparando prévia',
            txtCheckoutCancelledBody: 'Nenhuma cobrança foi feita. Você pode tentar novamente a qualquer momento.',
            txtTrackPreviewLabel: 'Prévia da faixa',
            txtTrackPreviewHelper: 'Esta prévia é um trecho de 15 segundos da sua faixa para avaliação',
            txtEmailLabel: 'Endereço de e-mail',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'Vamos usar isso para enviar o seu link de download.',
            txtCheckoutAction: 'Remover vocais por apenas {{price}}',
            txtCheckoutActionFallback: 'Remover vocais',
            txtCheckoutFailed: 'Não foi possível iniciar o checkout. Tente novamente.',
            txtInvalidEmail: 'Informe um endereço de e-mail válido.',
        },
        processing: {
            txtMissingTitle: 'ID do processamento ausente',
            txtMissingBody: 'Esta página precisa de um ID de processamento. Inicie uma nova prévia.',
            txtMissingAction: 'Voltar para upload',
            txtStatusFailed: 'Não foi possível buscar o status do processamento. Tente novamente.',
            txtErrorTitle: 'Algo deu errado',
            txtSupportAction: 'Falar com o suporte',
            txtConfirmingTitle: 'Confirmando pagamento',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Verificando atualizações',
            txtWorkingTitle: 'Processando sua faixa completa',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Começar outro',
            txtReadyTitle: 'Download pronto',
            txtReadyBody: 'Seu instrumental está pronto para download.',
            txtDownloadAction: 'Baixar',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Começar outro',
        },
        invalidJob: {
            txtTitle: 'ID de processamento inválido',
            txtBody: 'Esse processamento não foi encontrado. Inicie um novo upload.',
            txtAction: 'Começar de novo',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Suporte',
            txtTitle: 'Fale com o suporte',
            txtLastUpdatedLabel: 'Última atualização',
            txtLastUpdatedDate: '9 de fevereiro de 2026',
            txtSectionEmailTitle: 'E-mail',
            txtSectionEmailBodyPrefix: 'Envie um e-mail para',
            txtSectionIncludeJobIdTitle: 'Inclua o ID do processamento',
            txtSectionIncludeJobIdBody: 'Inclua o ID do processamento para localizarmos sua tarefa rapidamente. Se você pagou, inclua o e-mail usado no checkout.',
            txtSectionBugReportsTitle: 'Relatos de bugs',
            txtSectionBugReportsBody: 'Você também pode enviar relatos de bugs e solicitações de funcionalidades pelo link no rodapé.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Feedback',
            txtTitle: 'Relatos de bugs e solicitações de funcionalidades',
            txtSubtitle: 'A UNVOX ainda está no começo. Se algo parecer errado ou você tiver uma ideia, envie. Relatos claros são a forma mais rápida de colocar correções no ar.',
            txtWhatToIncludeTitle: 'O que incluir',
            txtChecklistExpectedVsActual: 'O que você esperava vs o que aconteceu',
            txtChecklistSteps: 'Passos para reproduzir (1, 2, 3)',
            txtChecklistBrowserOs: 'Seu navegador e sistema operacional',
            txtChecklistJobId: 'ID do processamento (se envolveu upload)',
            txtTipTitle: 'Dica',
            txtTipBody: 'Se estiver enviando por e-mail, você pode responder diretamente ao e-mail de entrega que recebeu e colar o modelo.',
            txtTemplateTitle: 'Modelo para copiar e colar',
            txtTemplateBody: 'Relato de bug / Solicitação de funcionalidade\n\nTipo: bug | funcionalidade\nResumo:\n\nDetalhes:\n- O que aconteceu:\n- O que você esperava:\n- Passos para reproduzir:\n  1.\n- Navegador/SO:\n\nOpcional:\n- ID do processamento:\n- URL do YouTube:\n- Captura de tela/vídeo:\n',
            txtTemplatePageLabel: 'Página',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'Copiar modelo',
            txtCopyActionCopied: 'Copiado',
            txtCopyActionFailed: 'Falha ao copiar',
            txtCopyHelpFailed: 'O acesso à área de transferência foi bloqueado. Você ainda pode selecionar o texto acima e copiar manualmente.',
            txtCopyHelpIdle: 'Nada aqui é enviado automaticamente. Esta página só ajuda você a formatar um bom relato.',
        },
    },
};
